import React from 'react';
import "./MutualFund.css"


function MutualFundsReturns() {



  return (
    <>
    
    <div className='return_div69'>
    <div className='iframe'>
    <iframe width="560" height="315"
     src="https://www.youtube.com/embed/YBTWCSLLnWg"
      title="YouTube video player" 
      frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
    allowfullscreen>

    </iframe>
<div class="credit-container">
<p class="credit-text">
      Powered by <a class="credit-link" href="https://www.mutualfundssahihai.com/en/what-is-a-mutual-fund">Mutual Fund Sahi Hai</a></p>
</div>
</div>



       <div className='description4' >
       
        <h2 className='Simplifying'>
        How do I get my returns in Mutual Funds?
        </h2>
      
     

        Like other asset classes, Mutual Funds returns are calculated by computing appreciation in the value of your investment over a period as compared to the initial investment made. 
        <br />
        <br />
        <strong style={{color: "#10b983"}}> Net Asset Value </strong> of Mutual Fund indicates its price and is used in calculating returns from your  <strong style={{color: "#10b983"}}>Mutual Fund investments.</strong>
        <br />
        <br />
        Return over a period is calculated as the difference in sale date<strong style={{color: "#10b983"}}>  NAV </strong> and purchase date NAV upon  purchase date NAV and converted to percentage by multiplying the result by 100 .
        <br />
        <br/>
        Any <strong style={{color: "#10b983"}}> net dividend*  </strong>or other income distribution by the fund during the holding period is also added to the capital appreciation while computing total returns.
        <br />
        <br />
        <strong style={{color: "#10b983"}}> Capital appreciation </strong>in Mutual Funds is reflected by increase in NAV over time. This happens because NAV of a fund is derived from stock prices of companies included in the portfolio of the fund, and the prices fluctuate every day.
        <br />
        <br />
        Change in NAV of a fund over time contributes to the capital appreciation or <strong style={{color: "#10b983"}}> loss in your holding.</strong> View the return performance of your investments in the account statement provided to you by the fund house. 
        <br />
        <br />

</div>



</div>

<div className='points'>

  
</div>

    </>
);
}
export default MutualFundsReturns;